import React from 'react';

import { translate } from "react-i18next";
import { Row, Col, Alert ,Card} from 'react-bootstrap';
import LoginPage from './LoginPage';
import { getURL } from '../../backend/Backend';

class RegValidatePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            RegValidate: false
        };

    }

    async componentDidMount() {
        const response = await fetch(getURL(`users/regValidate/${this.props.userId}/${this.props.uuid}`));
        const json = await response.json();
        //let newEvent = json;
        if (json.ok) {
            let oldState = this.state;

            this.setState({
                ...oldState,
                RegValidate: true
            });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                { this.state.RegValidate ?
                    <div>
                        <Row>
                            <Col>
                                <Alert key={'success'} variant={'success'}>
                                    {t("regValidateSuccessful")}
                                </Alert>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <LoginPage  forward={"home"}/>
                            </Col>
                        </Row>
                    </div>
                    :
                    <Row >
                        <Col></Col>
                    <Col lg={6}>
                    <Card className="text-left mt-5" >
                    <Card.Header className="text-danger"><h4>{t("regValidateUnsuccessfulTitle")}</h4></Card.Header>
                      <Card.Body >
                  
                            <Alert key={'danger'} variant={'danger'}>
                                {t("regValidateUnsuccessful")}
                            </Alert>
                     
                    </Card.Body>
                    </Card>
                    </Col>
                    <Col></Col>
                    </Row>
                }

            </div>

        );
    }

}

export default translate("translations")(RegValidatePage);